import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "new_chart_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChartHeader = _resolveComponent("ChartHeader")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showHeader)
      ? (_openBlock(), _createBlock(_component_ChartHeader, {
          key: 0,
          showDuration: _ctx.showDuration,
          stockInfo: _ctx.stockInfo,
          onHandleSelectedFilter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterChartData($event))),
          isCreateView: _ctx.isCreateView
        }, null, 8, ["showDuration", "stockInfo", "isCreateView"]))
      : _createCommentVNode("", true),
    (_ctx.data && _ctx.data.length)
      ? (_openBlock(), _createBlock(_component_apexchart, {
          key: 1,
          ref: "chart",
          type: "line",
          options: _ctx.options,
          series: _ctx.seriesData,
          height: "100%",
          width: "100%"
        }, null, 8, ["options", "series"]))
      : _createCommentVNode("", true)
  ]))
}